module.exports = __webpack_public_path__ + "img/ang3.cd4c9709.png";